<template>
	<div class="sk-widget sk-widget-perk">
		<img
			class="perk-image"
			src="/images/2k-loyalty-banner.png"
			alt="Referral Perk Image"
		/>
		<div>
			<h2>Share and Save</h2>
			<div class="subtitle">
				{{ progress }}
			</div>
			<UserReferral :couponCode="coupon" />
		</div>
	</div>
</template>

<style scoped>
.subtitle {
	margin-bottom: 0;
}
</style>

<script>
import UserReferral from "@/components/common/UserReferral.vue"

export default {
	name: "ReferralWidget",
	components: {
		UserReferral
	},
	props: {
		progress: String,
		coupon: String
	}
}
</script>